import { render, staticRenderFns } from "./Mining.vue?vue&type=template&id=df3e6140&scoped=true"
import script from "./Mining.vue?vue&type=script&lang=js"
export * from "./Mining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3e6140",
  null
  
)

export default component.exports